module.exports = __webpack_public_path__ + "img/douyin.4b1b18db.png";